import { createContext, useMemo, useState } from "react"

const PaginationContext = createContext()

export const PaginationProvider = ({ children }) => {
    const [direction, setDirection] = useState(0)
    const [cursor, setCursor] = useState(0)
    const [lastUrlLocation, setLastUrlLocation] = useState(null)

    const value = useMemo(() => {
      return {direction, setDirection, cursor, setCursor, lastUrlLocation, setLastUrlLocation}
    }, [direction, setDirection, cursor, setCursor, lastUrlLocation, setLastUrlLocation])
    
    return (
        <PaginationContext.Provider value={value}>
          {children}
        </PaginationContext.Provider>
      )
}

export default PaginationContext